import React, { useState, useContext, useEffect } from "react";
import { MDBTabsContent, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { useNavigate } from 'react-router-dom';
import CardLayout from "../CommonLayout/CardLayout";
import LoginForm from "./LoginForm";
import ForgotPasswordModal from "../PasswordChanges/ForgotPasswordModal";
import { UserContext } from '../../../Context/UserContext';
import InstallPWAAndroid from '../../../PWA/InstallPWAAndroid';
import InstallIosPrompt from '../../../PWA/InstallIosPrompt';
import constants from "../../../config/constants";
import { useLocation } from 'react-router-dom';
import useAxiosCall from '../../../Hooks/useAxiosCall';
import { SecureStorage } from '../../../Utilities/StorageEncryption';
import { setHelmet } from '../../../Common/useHelmet';
import seo from '../../../Common/seo.json';

const Login = () => {
  const { signIn } = useContext(UserContext);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { makeApiCall } = useAxiosCall();
  useEffect(() => {
    // localStorage.clear();
  }, []);
  const handleForgotPasswordClick = () => {
    window.open(constants.forgotPasswordUrl, '_blank');
  };
  useEffect(() => {
    localStorage.removeItem('tokenKey');
    localStorage.removeItem('domain');
    localStorage.removeItem('acctDbKey');
    localStorage.removeItem('pusherTransportTLS');
    localStorage.removeItem('company');
    localStorage.removeItem('companyKey');
    localStorage.removeItem('refreshToken');
    // Parse the query parameters
    const queryParams = new URLSearchParams(location.search);
    const qJwt = queryParams.get('qJwt');
    const page = queryParams.get('page');
    if (qJwt != undefined) {
      autoLogin(qJwt, page);
    }
  }, []);

  const autoLogin = async (qJwt, page) => {
    try {
      const requestData = {
        qJwt: qJwt
      };

      await makeApiCall({
        requestData,
        onSuccess: (data) => handleApiCallSuccess(data, page),
        onError: handleApiCallError,
        requestType: 'POST',
        url: 'autoLogin',
      });
    } catch (error) {
      console.log(error)
      console.error('API call error:', error);
    }
  }
  const handleApiCallSuccess = (data, page) => {
    const userData = {
      name: data.data.name,
      givenName: data.data.givenName,
      surname: data.data.surname,
    };
    signIn(userData);
    const tokenData = {
      value: data.data.token,
      timestamp: new Date().getTime(),
    };
    SecureStorage.setItem('tokenKey', JSON.stringify(tokenData));
    SecureStorage.setItem('refreshToken', data.data.refreshToken)
    
    // Ensure absolute path navigation by adding leading slash
    const absolutePath = page.startsWith('/') ? page : `/${page}`;
    navigate(absolutePath, { replace: true });
  };

  const handleApiCallError = (errorMessage) => {
    // setAlert({ type: 'error', message: errorMessage });
  };

  const handleCloseForgotPasswordModal = () => {
    setForgotPasswordModal(false);
  };

  const handleLogin = (data) => {
    const userData = {
      name: data.data.name,
      givenName: data.data.givenName,
      surname: data.data.surname,
    };
    signIn(userData);
    const tokenData = {
      value: data.data.token,
      timestamp: new Date().getTime(),
    };
    SecureStorage.setItem('tokenKey', JSON.stringify(tokenData));
    SecureStorage.setItem('refreshToken', data.data.refreshToken)
    navigate('/portal/home');
  };
  return (
    <>
    {process.env.REACT_APP_PWA_ENABLE == 1 && <InstallPWAAndroid />}
    {process.env.REACT_APP_PWA_ENABLE == 1 && <InstallIosPrompt />}
    {setHelmet(seo.parents.login.title)}
    <CardLayout title="Welcome to PropertyBoss">
      <MDBTabsContent className="mt-4">
        <LoginForm onSubmit={(userData) => handleLogin(userData)} />
        <div className="mt-3">
          <MDBRow>
            <MDBCol size="8" className="md-8">
              <p className="text-left">For Client Care, please call 864-297-7661 x2</p>
            </MDBCol>
            <MDBCol size="4" className="md-4">
              <span className="text-primary cursor-pointer text-right" onClick={handleForgotPasswordClick}>
                Forgot Password?
              </span>
            </MDBCol>
          </MDBRow>
        </div>
        {forgotPasswordModal && (
          <ForgotPasswordModal isOpen onClose={handleCloseForgotPasswordModal} />
        )}
      </MDBTabsContent>
    </CardLayout>
    </>
  );
};

export default Login;
